import {
  OSM,
  StadiaMaps,
  TileJSON,
  XYZ,
} from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import { getStandardLayerProps } from './utils'

export function createTileLayer(config) {
  let source

  switch (config.type) {
    case 'osm':
      source = new OSM({
        url: config.url ?? undefined,
        ...config.source,
      })
      break

    case 'stadia':
      source = new StadiaMaps({
        layer: config.source.layer,
        ...config.source,
      })
      break

    case 'tilejson':
      source = new TileJSON({
        url: config.url,
        ...config.source,
      })
      break

    case 'xyz':
      source = new XYZ({
        url: config.url,
        ...config.source,
      })
      break
  }

  return new TileLayer({
    ...getStandardLayerProps(config),
    source,
  })
}
